import firstImage from "../assets/images/pk/1.png";
import secondImage from "../assets/images/pk/2.gif";
import thirdImage from "../assets/images/pk/3.jpg";
import fourthImage from "../assets/images/pk/4.png";
import fifthImage from "../assets/images/pk/5.jpg";
import sixthImage from "../assets/images/pk/6.jpg";
import seventhImage from "../assets/images/pk/7.jpg";
import eighthImage from "../assets/images/pk/8.jpg";
import ninthImage from "../assets/images/pk/9.jpg";
import tenthImage from "../assets/images/pk/10.jpg";
import eleventhImage from "../assets/images/pk/11.jpg";
import twelfthImage from "../assets/images/pk/12.png";
import thirteenthImage from "../assets/images/pk/13.jpg";
function PravilnayaKosmetika() {
  return (
    <div className="project-info-pk">
      <div className="project-info-pk__container">
        <div className="project-info-pk__block">
          <h2 className="project-info-pk__title">Pravilnaya Kosmetika</h2>
          <p className="project-info-pk__tags">
            Брендинг, графика, упаковка, SMM
          </p>
        </div>
        <div className="project-info-pk__objectives">
          <div className="project-info-pk__task">
            <p className="project-info-pk__task-title">Задача:</p>
            <p className="project-info-pk__task-text">
              Дизайн для бренда уходовой косметики с акцентом на ботанику.
            </p>
          </div>
          <div className="project-info-pk__solution">
            <p className="project-info-pk__solution-title">Решение:</p>
            <p className="project-info-pk__solution-text">
              Знак-бабочка, как символ красоты и обновления. Это монограмма
              первых букв бренда.
            </p>
            <p className="project-info-pk__solution-text">
              Сочетание ботанической иллюстрации и векторной графики создает
              гибкий дизайн который подстраивается под разные линейки.
            </p>
          </div>
        </div>
      </div>
      <div className="project-info-pk__case">
        <div className="project-info-pk__description-case">
          <p className="project-info-pk__description-text">
            Вокруг логотипа необходимо оставлять пустое пространство — охранное
            поле.
          </p>
          <p className="project-info-pk__description-text">
            Ширина охранного поля равна ширине буквы N в логотипе.
          </p>
          <p className="project-info-pk__description-text">
            Минимальная высота логотипа: 8мм.
          </p>
          <p className="project-info-pk__description-text">
            Диджитал размер: 23px.
          </p>
        </div>
        <img className="project-info-pk__case-image" src={firstImage} alt="1" />
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={secondImage} alt="2" />
        <div className="project-info-pk__image-text-container">
          <p className="project-info-pk__image-text">
            Знак является монограмой из первых букв Pravilnaya Kosmetika.
          </p>
          <p className="project-info-pk__image-text">
            Он образует бабочку, как знак нежности, обновления и женственности.
          </p>
          <p className="project-info-pk__image-text">
            Знак симметричный и повторяется пластику шрифта логотипа.
          </p>
          <p className="project-info-pk__image-text">
            Охранное поле знака равна 1\3 высоты знака.
          </p>
        </div>
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={thirdImage} alt="3" />
        <div className="project-info-pk__image-text-container project-info-pk__image-text-container--second">
          <p className="project-info-pk__image-text">
            Фирменные растровые и векторные ботанические иллюстрации наносятся
            на носители.
          </p>
        </div>
      </div>
      <div className="project-info-pk__image-container project-info-pk__image-container--third">
        <img className="project-info-pk__image" src={fourthImage} alt="4" />
        <div className="project-info-pk__image-text-container project-info-pk__image-text-container--third">
          <p className="project-info-pk__image-text">
            Интимная линейка формируется черно-белой полупрозрачной
            иллюстрацией, подчеркивая нежность и деликатность темы.
          </p>
        </div>
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={fifthImage} alt="5" />
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={sixthImage} alt="6" />
        <div className="project-info-pk__image-text-container project-info-pk__image-text-container--fourth">
          <p className="project-info-pk__image-text">
            Линейка для лица формируется пастельной плашкой с цветочной
            иллюстрацией, отвечающей отдушке продуктов.
          </p>
        </div>
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={seventhImage} alt="7" />
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={eighthImage} alt="8" />
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={ninthImage} alt="9" />
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={tenthImage} alt="10" />
        <div className="project-info-pk__image-text-container project-info-pk__image-text-container--fifth">
          <p className="project-info-pk__image-text">
            Мужская линейка выполнена в строгом минималистичном стиле:
            тёмно-серые матовые этикетки подчёркивают премиальность и
            мужественность.
          </p>
          <p className="project-info-pk__image-text">
            Акцент этикетки сделан на ботанической иллюстрации зверобоя.
          </p>
        </div>
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image" src={eleventhImage} alt="11" />
        <div className="project-info-pk__image-text-container project-info-pk__image-text-container--sixth">
          <p className="project-info-pk__image-text">
            В баннерах используется фирменный шрифт.
          </p>
          <p className="project-info-pk__image-text">
            Использование сторонних шрифтов допустимо для акцентирования
            деталей.
          </p>
          <p className="project-info-pk__image-text">
            Минимализм — ключевое слово во всех дизайнах.
          </p>

          <p className="project-info-pk__image-text">
            Акцент на продукт или эффект.
          </p>
        </div>
      </div>
      <div className="project-info-pk__case">
        <div className="project-info-pk__description-case project-info-pk__description-case--second">
          <p className="project-info-pk__description-text">
            Сетка для социальных сетей имеет пастельной цветовой код.
          </p>
          <p className="project-info-pk__description-text">
            Передает нежное настроение.
          </p>
          <p className="project-info-pk__description-text">
            В сетке используется образ красивых девушек с чистым лицом, здоровой
            кожей, блестящими волосами.
          </p>

          <p className="project-info-pk__description-text">
            Активно внедряется фото продуктов с акцентными заголовками, а также
            их текстуры.
          </p>
        </div>
        <img
          className="project-info-pk__case-image project-info-pk__case-image--second"
          src={twelfthImage}
          alt="12"
        />
      </div>
      <div className="project-info-pk__image-container">
        <img className="project-info-pk__image project-info-pk__image--second" src={thirteenthImage} alt="13" />
      </div>
    </div>
  );
}

export default PravilnayaKosmetika;
